module.exports = __webpack_public_path__ + "static/img/img_jingdianwenxue.87a4453.87a4453f.jpg";